import React, { useEffect, useState } from 'react'
import DashboardSummary from '../DashboardSummaryNew';
import DashboardGroupedBarChart from "../DashboardGroupedBarChart";
import DashboardTable from '../DashboardTable';
import callPostApi from "../../../requests/PostRequests";
import * as Constants from '../../../requests/URLConstants';
import * as tableHeaders from './tableHeaders';
import moment from 'moment';
import * as DashboardUtils from '../DashboardUtils.js';
import TableToolbarDownload from '../../../common/TableToolbarDownload';
import * as DashboardConstants from '.././DashboardConstants';
import axios from "axios";
import * as workspaces from '../../../config/WorkspaceConstants'

const AutomationTrustIndex = (props) => {

    const [trustIndexSummaryData, setTrustIndexSummaryData] = useState([]);
    const [trustIndexSummmaryTableData, setTrustIndexSummmaryTableData] = useState([]);
    const [trustIndexSummmaryGraphData, setTrustIndexSummmaryGraphData] = useState([]);
    const [trustIndexSummaryLoading, setTrustIndexSummaryLoading] = useState(false);
    const [successRateByGeoTableData, setSuccessRateByGeoTableData] = useState([]);
    const [successRateByGeoLoading, setSuccessRateByGeoLoading] = useState([]);
    const [botSummaryReportData, setBotSummaryReportData] = useState([]);
    const [botSummaryReportDataLoading, setBotSummaryReportDataLoading] = useState(false);
    const [automataStartedOnTimeGraphData, setAutomataStartedOnTimeGraphData] = useState([]);
    const [automataStartedOnTimeTableData, setAutomataStartedOnTimeTableData] = useState([]);
    const [automataStartedOnTimeLoading, setAutomataStartedOnTimeLoading] = useState(false);
    const [automataRunsOnTimeGraphData, setAutomataRunsOnTimeGraphData] = useState([]);
    const [automataRunsOnTimeTableData, setAutomataRunsOnTimeTableData] = useState([]);
    const [automataRunsOnTimeLoading, setAutomataRunsOnTimeLoading] = useState(false);

    useEffect(() => {
        getTrustIndexSummary(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getBotSummaryByGeo(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getBotSummary(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getAutomataStartedOnTime(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getAutomataRunsOnTime(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
    }, [props.preferencesChanged]);

    const getTrustIndexSummaryData = (param) => {
        let summary = [
            {
                title: DashboardConstants.AverageSuccessRate,
                value: param.avgSucessRate,
                showPercent: true
            },
            {
                title: DashboardConstants.TotalRuns,
                value: param.runs
            },
            {
                title: DashboardConstants.Completions,
                value: param.completions
            },
            {
                title: DashboardConstants.Terminations,
                value: param.termination
            },
        ];
        setTrustIndexSummaryData(summary);
    };

    const prepareResourceUtilizationData = (response) => {
        let tableData = [];
        let tableObj = {};
        let graphData = [];
        let graphObj = {};
        let buckets = [];
        let sucessRate;
        let avgSucessRate = 0, runs = 0, completions = 0, termination = 0;
        let summaryData = { avgSucessRate: avgSucessRate, runs: runs, completions: completions, termination: termination };

        if (response?.aggregations) {
            buckets = response?.aggregations?.priority?.buckets;
            for (let i = 0; i < buckets.length; i++) {
                tableObj = {
                    id: (i + 1).toString(),
                    priority: buckets[i].key,
                    totalCompletions: buckets[i].Completions.value ? buckets[i].Completions.value : 0,
                    schMisses: buckets[i].SchdMiss.value ? buckets[i].SchdMiss.value : 0,
                    terminations: buckets[i].Term.value ? buckets[i].Term.value : 0,
                }
                tableObj.executions = buckets[i].doc_count ? buckets[i].doc_count : 0;
                tableObj.reruns = buckets[i].ReRuns.value ? buckets[i].ReRuns.value : 0;
                tableObj.successRate = ((buckets[i].Completions.value / (buckets[i].doc_count - buckets[i].ReRuns.value + buckets[i].SchdMiss.value)) * 100).toFixed(2) + '%';
                avgSucessRate = (avgSucessRate + ((buckets[i].Completions.value / (buckets[i].doc_count - buckets[i].ReRuns.value + buckets[i].SchdMiss.value)) * 100));
                runs = runs + buckets[i].doc_count;
                completions = completions + buckets[i].Completions.value;
                termination = termination + buckets[i].Term.value;
                sucessRate = tableObj.successRate !== 0 ? tableObj.successRate.replace("%", '') : 0;
                graphObj = {
                    group: buckets[i].key,
                    key: buckets[i].key,
                    value: sucessRate ? sucessRate : 0
                };
                tableData.push(tableObj);
                graphData.push(graphObj);
            }
        }
        summaryData = { avgSucessRate: avgSucessRate ? ((avgSucessRate / buckets.length).toFixed(2)) : 0, runs: runs, completions: completions, termination: termination };
        return { tableData, graphData, summaryData };
    };

    const getTrustIndexSummary = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setTrustIndexSummaryLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETAUTOMATIONTRUSTINDEXSUMMARYSHAREDPROD, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(response => {
                    formattedData = prepareResourceUtilizationData(response);
                    setTrustIndexSummmaryTableData(formattedData.tableData);
                    setTrustIndexSummmaryGraphData(formattedData.graphData);
                    getTrustIndexSummaryData(formattedData.summaryData);
                    setTrustIndexSummaryLoading(false);
                }).catch((error) => {
                    setTrustIndexSummaryLoading(false);
                });
        }
    }

    const prepareSuccessRateByGeoData = (response) => {
        let tableData = [];
        let tableObj = {};
        let buckets = [];
        let statusBucket = [];
        let expandedTable = [], expandedItemObj = {};
        let reRuns;
        let executionTotal = 0, completionTotal = 0, stoppedTotal = 0, rerunTotal = 0, schmissesTotal = 0,
            terminationsTotal = 0, successRatetotal = 0, rerunfieldTotal = 0;
        if (response?.aggregations) {
            buckets = response?.aggregations.geography.buckets;
            for (let i = 0; i < buckets.length; i++) {
                rerunfieldTotal = 0; successRatetotal = 0; completionTotal = 0; stoppedTotal = 0; rerunTotal = 0;
                schmissesTotal = 0; terminationsTotal = 0; executionTotal = 0;
                expandedTable = [];
                tableObj = {
                    id: (i + 1).toString(),
                    geo: buckets[i].key,
                }
                statusBucket = buckets[i].process_criticality.buckets;
                for (let j = 0; j < statusBucket.length; j++) {
                    rerunfieldTotal = rerunfieldTotal + statusBucket[j].ReRuns.value;
                    completionTotal = completionTotal + statusBucket[j].Completions.value;
                    schmissesTotal = schmissesTotal + statusBucket[j].SchedulerMiss.value;
                    terminationsTotal = terminationsTotal + statusBucket[j].Term.value;
                    expandedItemObj = {
                        id: j + 1,
                        geo: statusBucket[j].key,
                        geography: buckets[i].key,
                        completions: statusBucket[j].Completions.value,
                        schMisses: statusBucket[j].SchedulerMiss.value,
                        terminations: statusBucket[j].Term.value
                    }
                    expandedItemObj.executions = statusBucket[j].doc_count;
                    executionTotal = executionTotal + statusBucket[j].doc_count;
                    reRuns = statusBucket[j].ReRuns.value;
                    successRatetotal = successRatetotal + ((statusBucket[j].Completions.value / (statusBucket[j].doc_count - reRuns + statusBucket[j].SchedulerMiss.value)) * 100);
                    expandedItemObj.reruns = reRuns ? reRuns : 0;
                    expandedItemObj.successRate = statusBucket[j].Completions.value ? (((statusBucket[j].Completions.value / (statusBucket[j].doc_count - reRuns + statusBucket[j].SchedulerMiss.value)) * 100).toFixed(2) + "%") : (0).toFixed(2) + "%";
                    rerunTotal = rerunTotal + reRuns;
                    expandedTable.push(expandedItemObj);
                    tableObj.expandedItems = expandedTable;
                }
                tableObj.executions = executionTotal;
                tableObj.completions = completionTotal;
                tableObj.stopped = stoppedTotal;
                tableObj.reruns = rerunTotal;
                tableObj.schMisses = schmissesTotal;
                tableObj.terminations = terminationsTotal;
                tableObj.successRate = (successRatetotal / statusBucket.length).toFixed(2) + '%';
                tableData.push(tableObj);
            }
        }
        return { tableData };
    };

    const getBotSummaryByGeo = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setSuccessRateByGeoLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETBOTSUMMARYBYGEOSHAREDPROD, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(response => {
                    formattedData = prepareSuccessRateByGeoData(response);
                    setSuccessRateByGeoTableData(formattedData.tableData);
                    setSuccessRateByGeoLoading(false);
                }).catch((error) => {
                    setSuccessRateByGeoLoading(false);
                });
        }
    }

    const prepareBotSummaryReportData = (response) => {
        let tableObj = {};
        let tableData = [];
        let reRuns;

        if (response?.aggregations) {
            let buckets = response?.aggregations.BOTID.buckets;
            for (let i = 0; i < buckets.length; i++) {
                let leadPlatformBucket = buckets[i].LeadPlatform.buckets;
                for (let j = 0; j < leadPlatformBucket.length; j++) {
                    let subAreaBucket = leadPlatformBucket[j].SubArea.buckets;
                    for (let k = 0; k < subAreaBucket.length; k++) {
                        let srvcprocessNameBucket = subAreaBucket[k].Service_prc_name.buckets;
                        for (let l = 0; l < srvcprocessNameBucket.length; l++) {
                            let processNameBucket = srvcprocessNameBucket[l].ProcessName.buckets
                            for (let m = 0; m < processNameBucket.length; m++) {
                                let geographyBucket = processNameBucket[m].Geography.buckets
                                for (let n = 0; n < geographyBucket.length; n++) {
                                    let processCriticalityBucket = geographyBucket[n].ProcessCriticality.buckets;
                                    for (let o = 0; o < processCriticalityBucket.length; o++) {
                                        let technologyBucket = processCriticalityBucket[o].Technology.buckets;
                                        for (let p = 0; p < technologyBucket.length; p++) {
                                            let deliveryModelBucket = technologyBucket[p].DeliveryModel.buckets;
                                            for (let q = 0; q < deliveryModelBucket.length; q++) {
                                                let supportStatusBucket = deliveryModelBucket[q].SupportStatus.buckets;
                                                for (let r = 0; r < supportStatusBucket.length; r++) {
                                                    tableObj = {
                                                        id: ((i + j + k + 1).toString()) + Math.random(1),
                                                        botId: buckets[i].key,
                                                        leadPlatform: leadPlatformBucket[j].key ? leadPlatformBucket[j].key : 0,
                                                        subArea: subAreaBucket[k].key ? subAreaBucket[k].key : 0,
                                                        processName: processNameBucket[m].key ? processNameBucket[m].key : 0,
                                                        geo: geographyBucket[n].key ? geographyBucket[n].key : 0,
                                                        processCritical: processCriticalityBucket[o].key ? processCriticalityBucket[o].key : 0,
                                                        requestedBy: technologyBucket[p].key ? technologyBucket[p].key : 0,
                                                        deliveryModel: deliveryModelBucket[q].key ? deliveryModelBucket[q].key : 0,
                                                        supportStatus: supportStatusBucket[r].key ? supportStatusBucket[r].key : 0,
                                                        completions: supportStatusBucket[r].Completions.value ? supportStatusBucket[r].Completions.value : 0,
                                                        schMisses: supportStatusBucket[r].SchedulerMisses.value ? supportStatusBucket[r].SchedulerMisses.value : 0,
                                                        terminations: supportStatusBucket[r].Terminations.value ? supportStatusBucket[r].Terminations.value : 0,
                                                    }
                                                    reRuns = supportStatusBucket[r].ReRuns.value ? supportStatusBucket[r].ReRuns.value : 0;
                                                    tableObj.totalRuns = processNameBucket[m].doc_count ? processNameBucket[m].doc_count : 0;
                                                    tableObj.reruns = reRuns;
                                                    tableObj.successRate = supportStatusBucket[r].Completions.value > 0 ? (((supportStatusBucket[r].Completions.value / (processNameBucket[m].doc_count - reRuns + supportStatusBucket[r].SchedulerMisses.value)) * 100).toFixed(2)) + '%' : 0;
                                                    tableData.push(tableObj);
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return { tableData };
    };

    const getBotSummary = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setBotSummaryReportDataLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            let url = Constants.GETBOTSUMMARYSHAREDPROD;
            callPostApi(url, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(response => {
                    formattedData = prepareBotSummaryReportData(response);
                    setBotSummaryReportData(formattedData.tableData);
                    setBotSummaryReportDataLoading(false);
                }).catch((error) => {
                    setBotSummaryReportDataLoading(false);
                });
        }
    }

    const prepareAutomataStartedOnTimeData = (response) => {
        let graphObj = {};
        let graphData = [];
        let tableObj = {};
        let tableData = [];
        let totalRuns;

        if (response?.aggregations) {
            let buckets = response?.aggregations.priority.buckets;
            for (let i = 0; i < buckets.length; i++) {
                let SchedulerMisses = buckets[i].SchedulerMisses.value ? buckets[i].SchedulerMisses.value : 0;
                let Reruns = buckets[i].Reruns.value ? buckets[i].Reruns.value : 0;
                totalRuns = buckets[i].doc_count - Reruns;
                graphObj = {
                    group: buckets[i].key,
                    key: buckets[i].key,
                    value: ((totalRuns - SchedulerMisses) / totalRuns) * 100
                }
                tableObj = {
                    id: (i + 1).toString(),
                    priority: buckets[i].key,
                    scheduleMisses: SchedulerMisses,
                    totalRuns: totalRuns,
                    startedOnTime: totalRuns - SchedulerMisses,
                    startedOnTimePercentage: (((totalRuns - SchedulerMisses) / totalRuns) * 100).toFixed(2) + "%"
                }
                graphData.push(graphObj);
                tableData.push(tableObj);
            }
        }
        return { graphData, tableData };
    };

    const getAutomataStartedOnTime = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setAutomataStartedOnTimeLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETAUTOMATASTARTEDONTIME, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(response => {
                    formattedData = prepareAutomataStartedOnTimeData(response);
                    setAutomataStartedOnTimeGraphData(formattedData.graphData);
                    setAutomataStartedOnTimeTableData(formattedData.tableData);
                    setAutomataStartedOnTimeLoading(false);
                }).catch((error) => {
                    setAutomataStartedOnTimeLoading(false);
                });
        }
    }

    const prepareAutomataRunsOnTimeData = (response) => {
        let graphObj = {};
        let graphData = [];
        let tableObj = {};
        let tableData = [];
        let totalExecution = 0;

        if (response?.aggregations) {
            let buckets = response?.aggregations.priority.buckets;
            for (let i = 0; i < buckets.length; i++) {
                totalExecution = buckets[i].doc_count ? buckets[i].doc_count : 0;
                let Longruncount = buckets[i].Longruncount.value ? buckets[i].Longruncount.value : 0
                graphObj = {
                    group: buckets[i].key,
                    key: buckets[i].key,
                    value: ((totalExecution - Longruncount) / totalExecution) * 100
                }
                tableObj = {
                    id: (i + 1).toString(),
                    priority: buckets[i].key,
                    totalRuns: totalExecution,
                    runOnTime: totalExecution - Longruncount,
                    runOnTimePercentage: (((totalExecution - Longruncount) / totalExecution) * 100).toFixed(2) + '%'
                }
                graphData.push(graphObj);
                tableData.push(tableObj);
            }
        }
        return { graphData, tableData };
    };

    const getAutomataRunsOnTime = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setAutomataRunsOnTimeLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETAUTOMATARUNSONTIME, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(response => {
                    formattedData = prepareAutomataRunsOnTimeData(response);
                    setAutomataRunsOnTimeGraphData(formattedData.graphData);
                    setAutomataRunsOnTimeTableData(formattedData.tableData);
                    setAutomataRunsOnTimeLoading(false);
                }).catch((error) => {
                    setAutomataRunsOnTimeLoading(false);
                });
        }
    }

    const getPayload = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        let calenderInterval = DashboardUtils.getCalenderInterval(timeFilterSelections);
        let timeZone = moment.tz.guess();
        let technology;
        let franchise;
        let client;
        let bodyJSON;

        if (workspace === workspaces.automation_ops) {
            technology = dashboardFilterSelectionsAutomation.technology;
            franchise = dashboardFilterSelectionsAutomation.franchise;
            client = dashboardFilterSelectionsAutomation.client;
            bodyJSON = {
                "filters": {
                    "time": {
                        "startDateTime": timeFilterSelections.startDateTime,
                        "endDateTime": timeFilterSelections.endDateTime
                    },
                    "franchises": franchise,
                    "clients": client,
                    "technologies": technology,
                    "deployment_models": dashboardFilterSelectionsAutomation.deployment_model,
                    "business_competencies": dashboardFilterSelectionsAutomation.competency,
                    "automata_priority": dashboardFilterSelectionsAutomation.priority,
                    "status": dashboardFilterSelectionsAutomation.status,
                    "automata_state": dashboardFilterSelectionsAutomation.automata_state,
                    "automata_name": dashboardFilterSelectionsAutomation.automata_activity_name,
                    "bot_id": dashboardFilterSelectionsAutomation.bot_id,
                    "buisness_component": dashboardFilterSelectionsAutomation.buisness_component
                },
                "interval": {
                    "calender_Interval": calenderInterval,
                    "time_zone": timeZone
                },
                "workspace": workspace
            };
        }
        return bodyJSON;
    };

    return (
        <div className="top-margin dashboard sla-compliance">
            <div className="dashboard-detail-container col-lg-12 no-gutters">
                <div className="dashboard-roleContainer col-lg-12">
                    <DashboardSummary loading={trustIndexSummaryLoading} summary={trustIndexSummaryData} title={DashboardConstants.AutomationTrustIndexSummary} />
                </div>
                <div className="dashboard-charts-container">
                    <div className="report-title">
                    <div>{DashboardConstants.DetailedView}</div>
                    </div>
                    <section className="border-bottom">
                        <div className="tile-view">
                            <div className="report-container">
                                <DashboardGroupedBarChart
                                    loading={trustIndexSummaryLoading}
                                    title={DashboardConstants.TrustIndexSummary}
                                    graphAxesTitle={DashboardConstants.SuccessRate}
                                    graphBottomTitle={DashboardConstants.Priority}
                                    groupedBarChartData={trustIndexSummmaryGraphData}
                                    isPercentage={true}
                                />
                            </div>
                            <div className="report-container">
                                <DashboardTable loading={trustIndexSummaryLoading} rows={trustIndexSummmaryTableData} headers={tableHeaders.trustIndexSummaryTableHeaders}
                                    showPagination={true} isSortingAllowed={true} />
                            </div>
                        </div>
                    </section>
                    <section className="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            <div>{DashboardConstants.SuccessRateByGeo}</div>
                            <div className="download-button">
                                <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={successRateByGeoTableData} headers={tableHeaders.successRateTableHeaders} title={DashboardConstants.SuccessRateByGeo} filename={DashboardConstants.SuccessRateFileName} label={DashboardConstants.Download} />
                            </div>
                        </div>
                        <div className="bold-border-table nested-table">
                            <DashboardTable loading={successRateByGeoLoading} rows={successRateByGeoTableData}
                                headers={tableHeaders.successRateTableHeaders} showPagination={true} isSortingAllowed={true} isExpandable={true}
                            />
                        </div>
                    </section>
                    <section className="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            <div>{DashboardConstants.BotSummaryReport}</div>
                            <div className="download-button">
                                <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={botSummaryReportData} headers={tableHeaders.botSummaryReportTableHeaders} title={DashboardConstants.BotSummaryReport} filename={DashboardConstants.BotSummaryReportFileName} label={DashboardConstants.Download} />
                            </div>
                        </div>
                        <div className="bold-border-table nested-table">
                            <DashboardTable loading={botSummaryReportDataLoading} rows={botSummaryReportData}
                                headers={tableHeaders.botSummaryReportTableHeaders} showPagination={true} isSortingAllowed={true}
                            />
                        </div>
                    </section>
                    <section className="border-bottom">
                        <div className="tile-view">
                            <div className="report-container">
                                <DashboardGroupedBarChart
                                    loading={automataStartedOnTimeLoading}
                                    title={DashboardConstants.AutomataStartedOnTime}
                                    graphAxesTitle={DashboardConstants.StartedOnTime}
                                    graphBottomTitle={DashboardConstants.Priority}
                                    groupedBarChartData={automataStartedOnTimeGraphData}
                                    isPercentage={true}
                                />
                                <div className="bold-border-table">
                                    <DashboardTable loading={automataStartedOnTimeLoading} rows={automataStartedOnTimeTableData} headers={tableHeaders.automataStartedOnTimeTableHeaders}
                                        showPagination={true} isSortingAllowed={true} />
                                </div>
                            </div>
                            <div className="report-container">
                                <DashboardGroupedBarChart
                                    loading={automataRunsOnTimeLoading}
                                    title={DashboardConstants.AutomataRunsOnTime}
                                    graphAxesTitle={DashboardConstants.RunsOnTime}
                                    graphBottomTitle={DashboardConstants.Priority}
                                    groupedBarChartData={automataRunsOnTimeGraphData}
                                    isPercentage={true}
                                />
                                <div className="bold-border-table">
                                    <DashboardTable loading={automataRunsOnTimeLoading} rows={automataRunsOnTimeTableData} headers={tableHeaders.automataRunsOnTimeTableHeaders}
                                        showPagination={true} isSortingAllowed={true} />
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default AutomationTrustIndex;
